import { render, staticRenderFns } from "./listInfo.vue?vue&type=template&id=0b1b0e48&scoped=true"
import script from "./listInfo.vue?vue&type=script&lang=js"
export * from "./listInfo.vue?vue&type=script&lang=js"
import style0 from "./listInfo.vue?vue&type=style&index=0&id=0b1b0e48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1b0e48",
  null
  
)

export default component.exports